import { BaseDto } from "src/dtos/common/baseDto";

/** 월근태 API 필드와 그리드의 편집 상태를 표현한다. */
export interface HrmAttendMonthlyDto extends BaseDto {
    empNo: string; // 사원번호
    workYm: string; // 근무년월 YYYYMM
    compCd: string; // 월근태 행에 저장된 사업장코드
    totWorkDays: number; // 근무일수
    dayShiftDays: number; // 주간 근무일수
    nightShiftDays: number; // 야간 근무일수
    totWorkHours: number; // 정상시간 합계
    totOverHours: number; // 연장시간 합계
    totNightHours: number; // 야간시간 합계
    totHolidayHours: number; // 휴일시간 합계
    totOutHours: number; // 근무 제외 외출시간 합계
    outCount: number; // 근무 제외 외출횟수
    totPubOutHours: number; // 공용외출시간 합계
    absentDays: number; // 결근일수
    lateCount: number; // 지각 횟수
    totLateMin: number; // 지각분 합계
    leaveEarlyCount: number; // 조퇴 횟수
    totEarlyMin: number; // 조퇴분 합계
    remark: string; // 비고
    inserted: boolean; // true이면 그리드에서 새로 만든 행이다. 이 화면에서는 행을 추가하지 않는다.
    isModified: boolean; // true이면 저장하지 않은 셀 변경이 있다.
}

/** 월근태 행의 초기값이며 서버 집계 수치는 조회 응답으로 교체된다. */
export const defaultHrmAttendMonthlyDto: HrmAttendMonthlyDto = {
    valueIndex: 0,
    orderIndex: 0,
    orderIndexSeq: 0,
    empNo: '',
    workYm: '',
    compCd: '',
    totWorkDays: 0,
    dayShiftDays: 0,
    nightShiftDays: 0,
    totWorkHours: 0,
    totOverHours: 0,
    totNightHours: 0,
    totHolidayHours: 0,
    totOutHours: 0,
    outCount: 0,
    totPubOutHours: 0,
    absentDays: 0,
    lateCount: 0,
    totLateMin: 0,
    leaveEarlyCount: 0,
    totEarlyMin: 0,
    remark: '',
    inserted: false,
    isModified: false,
};
